// import { Badge } from "@workspace/web-ui/components/badge"
// import { Dialog, DialogContent, DialogTrigger, DialogPortal, DialogOverlay } from "@workspace/web-ui/components/dialog"
// import { cn } from "@workspace/web-ui/lib/utils"
// import { format } from "date-fns"
// import { CalendarEvent } from "../../../components"
// import { Button } from "@workspace/web-ui/components/button"

// interface RefillCardProps {
//   appointment: CalendarEvent & {
//     status?: 'pending' | 'rejected' | 'accepted'
//   }
//   isSelected: boolean
//   onOpen: (id: string) => void
//   onClose: () => void
// }

// const formatTimeRange = (start: Date, end: Date) => {
//   return `${format(start, "h:mm a")} - ${format(end, "h:mm a")}`
// }

// // Mock data for testing
// const mockRefillStatus: ('pending' | 'rejected' | 'accepted')[] = [
//   'pending',
//   'rejected',
//   'accepted'
// ];

// export function RefillCard({ appointment, isSelected, onOpen, onClose }: RefillCardProps) {
 
//   console.log("appointment balbagsjyflug")
 
//   // Temporarily assign random status for mock data
//   const mockStatus = mockRefillStatus[Math.floor(Math.random() * mockRefillStatus.length)];
//   const refillData = {
//     ...appointment,
//     status: mockStatus,
//     // Mock data for the modal
//     daysRemaining: 5,
//     weightData: {
//       initial: { value: 75, date: new Date('2024-01-01') },
//       current: { value: 72, date: new Date() },
//       goal: { value: 70, progress: 60 }
//     },
//     program: "Weight Management Program",
//     sideEffects: ["Mild headache", "Nausea"],
//     medications: ["Medication A - 10mg daily", "Medication B - 5mg twice daily"]
//   };

//   return (
//     <Dialog
//       open={isSelected}
//       onOpenChange={(open) => {
//         if (open) onOpen(refillData.id)
//         else onClose()
//       }}
//     >
//       <DialogTrigger className="" asChild>
//         <div
//           className={cn(
//             "p-8 rounded-md max-w-[800px] bg-red-500 flex flex-col cursor-pointer",
//             refillData.status === "pending"
//               ? "border border-[#4272DD] bg-[#4272DD] text-white"
//               : refillData.status === "rejected"
//                 ? "bg-[#ECECED] border border-white text-[#2D2F35]"
//                 : "bg-white border border-[#4272DD] text-[#2D2F35]" // accepted
//           )}
//         >
//           <div className="flex items-center space-x-3 mb-1">
//             <p className="font-medium">Refill Request: {refillData.title}</p>
//             <Badge 
//               className={`rounded-full px-2 text-xs font-medium capitalize
//                 ${refillData.status === "pending"
//                   ? "text-[#4272DD] bg-white border border-gray-300 hover:bg-gray-300"
//                   : refillData.status === "rejected"
//                     ? "text-[#2D2F35] hover:bg-transparent bg-white border border-white"
//                     : "text-[#4272DD] hover:bg-transparent bg-transparent border border-[#4272DD]" // accepted
//                 }`}
//             >
//               {refillData.status}
//             </Badge>
//           </div>
//           <p className="text-sm">{formatTimeRange(refillData.start, refillData.end)}</p>
//         </div>
//       </DialogTrigger>
//       <DialogPortal>
//         <DialogOverlay className="bg-black/80" />
//         <DialogContent className="max-w-md rounded-lg p-0 bg-white sm:max-h-[80vh] flex flex-col">
//           <div className="flex-1 overflow-y-auto hide-scrollbar">
//             {/* Priority banner - keeping it fixed at top */}
//             <div className="sticky top-0 p-4 bg-white">
//                 <p>Medication Refill Request</p>
//             </div>
//             <div className="bg-[#FFF6E7] border-l-4 border-l-[#EC980C] p-3">
//               <p className="text-sm">
//                 <span className="font-semibold">Priority Request:</span> Patient has {refillData.daysRemaining} days of
//                 medication remaining
//               </p>
//             </div>

//             <div className="space-y-4">
//               {/* Weight information */}
//               <div className="bg-[#EBF0FB] py-4">
//               <div className="grid grid-cols-3 gap-4 p-4 text-center">
//                 <div>
//                   <p className="text-sm text-gray-600">Initial Weight</p>
//                   <p className="text-2xl font-semibold">{refillData.weightData.initial.value} kg</p>
//                   <p className="text-xs text-gray-500">{format(refillData.weightData.initial.date, "MMM d, yyyy")}</p>
//                 </div>
//                 <div>
//                   <p className="text-sm text-gray-600">Current Weight</p>
//                   <p className="text-2xl font-semibold">{refillData.weightData.current.value} kg</p>
//                   <p className="text-xs text-gray-500">{format(refillData.weightData.current.date, "MMM d, yyyy")}</p>
//                 </div>
//                 <div>
//                   <p className="text-sm text-gray-600">Weight Goal</p>
//                   <p className="text-2xl font-semibold">{refillData.weightData.goal.value} kg</p>
//                   <p className="text-xs text-gray-500">Progress: {refillData.weightData.goal.progress}%</p>
//                 </div>
//               </div>

//               {/* Patient log button */}
//               <div className="px-4">
//                 <Button variant="outline" className="w-full">
//                   Go to Patient log
//                 </Button>
//               </div>
//               </div>

//               {/* Patient Information */}
//               <div className="px-4 grid grid-cols-2 gap-4">
//                 <div>
//                   <p className="text-sm text-gray-600">Patient Name</p>
//                   <p className="font-medium">{refillData.title}</p>
//                 </div>
//                 <div>
//                   <p className="text-sm text-gray-600">Program Enrollment</p>
//                   <p className="font-medium">{refillData.program}</p>
//                 </div>
//                 <div className="col-span-2">
//                   <p className="text-sm text-gray-600">Reported side effects</p>
//                   <p className="font-medium">{refillData.sideEffects.join(", ")}</p>
//                 </div>
//               </div>

//               {/* Medications */}
//               <div className="px-4">
//                 <p className="text-sm text-gray-600 uppercase mb-2">MEDICATION</p>
//                 <div className="space-y-2">
//                   {refillData.medications.map((medication, index) => (
//                     <div key={index} className="p-3 border rounded-md bg-gray-50">
//                       {medication}
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Action buttons - fixed at bottom */}
//           <div className="flex justify-end gap-2 p-4 border-t bg-white">
//             <Button variant="destructive" className="bg-[#E12121] rounded-[8px] hover:bg-red-600">
//               Reject Refill
//             </Button>
//             <Button className="bg-blue-500 rounded-[8px] hover:bg-blue-600">
//               Approve Refill
//             </Button>
//           </div>
//         </DialogContent>
//       </DialogPortal>
//     </Dialog>
//   )
// }

import { useState } from "react";
import { MedicalRefillsComponent } from "~/features/dashboard/components/refills";
import { RefillCard } from "./refill-card-details";
import { CalendarEvent } from "../../../components";

interface RefillCardProps {
  appointment: CalendarEvent & {
    status?: 'pending' | 'rejected' | 'accepted'
  }
  isSelected: boolean
  onOpen: (id: string) => void
  onClose: () => void
}

const RefillCardModal = ({ appointment }: RefillCardProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRefillId, setSelectedRefillId] = useState("");

  const handleSelectRefill = (id: string) => {
    setSelectedRefillId(id);
    setIsOpen(true);
  };

  return (
    <div className="p-4">
      {/* RefillCard that opens the MedicalRefillsComponent when clicked */}
      <RefillCard 
        appointment={appointment} 
        onSelectRefill={handleSelectRefill} 
      />

      {/* MedicalRefillsComponent that shows when a refill card is clicked */}
      <MedicalRefillsComponent
        open={isOpen}
        onOpenChange={setIsOpen}
        refillId={selectedRefillId}
      />
    </div>
  );
};

export default RefillCardModal;